import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ROUTES } from './api-routes';
import { DEFAULT_JSON_HEADERS } from './headers.config';
import { AtecoCode, Company, CompanyMember } from '../interfaces/company-interfaces';
import { combineAll, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(private http: HttpClient) { }

  addCompany(name: string, industryCode: string): Observable<any> {
    const payload = {
      name: name,
      industry_code: industryCode,
    };

    return this.http.post<Company>(
      API_ROUTES.COMPANY.DEFAULT,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  getCompany(id: string): Observable<any> {
    const payload = {};

    return this.http.get<Company>(
      `${API_ROUTES.COMPANY.DEFAULT}${id}`,
      payload,
    );
  }

  update(updatedCompany: Company): Observable<any> {
    const payload = JSON.stringify(updatedCompany);

    return this.http.post<Company>(
      `${API_ROUTES.COMPANY.DEFAULT}${updatedCompany.id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  addUserToCompany(companyId: string): Observable<any> {
    return this.http.post<Company>(
      `${API_ROUTES.COMPANY.DEFAULT}${companyId}/add-user`,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  getMembers(companyId: string): Observable<any> {
    return this.http.get<CompanyMember[]>(
      `${API_ROUTES.COMPANY.DEFAULT}${companyId}/members`,
    );
  }

  removeUserFromCompany(userId: string, companyId: string): Observable<any> {

    return this.http.post<string>(
      `${API_ROUTES.COMPANY.DEFAULT}{id}/remove-user/${userId}?company_id=${companyId}`,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  getAtecoCodes() {
    return this.http.get<AtecoCode[]>(
      `${API_ROUTES.COMPANY.ATECO_CODES}`,
    );
  }
}
